var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-xs-center pt-3"},[_c('span',{staticClass:"order-text-pagename elevation-2"},[_vm._v("New Order")]),_c('transition',{attrs:{"name":"slide-x-reverse-transition","mode":"out-in"}},[_c('orderListTable',{attrs:{"fetching_order":_vm.isLoading,"orderList":_vm.orderList}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }